import React from 'react';
import { bool, shape, string } from 'prop-types';

const Ai = ({
  className = 'icon',
  notUseClass = false,
  style = {},
}) => (
  <svg className={notUseClass ? '' : className} style={style} width="1em" height="1em" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M13.2695 11.2432L15.5 12.2573L13.2695 13.2704L12.2563 15.5L11.243 13.2704L9.01341 12.2573L11.243 11.2432L12.2563 9.01363L13.2695 11.2432Z" fill="url(#paint0_linear_15654_38884)" />
    <path d="M13.4727 0.5C12.3931 3.15483 11.9838 5.47574 11.4567 7.39182L9.96037 6.71084C10.0534 6.36044 10.1476 5.98218 10.2481 5.57208C10.4598 4.70811 10.6935 3.73994 11.0015 2.69119C9.72029 2.99062 8.57826 3.29937 7.56942 3.64073C5.87419 4.21439 4.65893 4.84537 3.81733 5.58167C3.01236 6.28609 2.50083 7.12735 2.26697 8.25853C2.08474 9.14027 2.07103 10.3378 2.26697 11.7279C2.81227 11.6596 3.33085 11.6082 3.81384 11.5614L3.88622 11.5544C4.74118 11.4715 5.45101 11.4025 6.08882 11.2858L6.78029 12.7002C5.13689 13.0673 3.16377 13.0499 0.946804 13.4736L0.860479 13.0568C-0.87317 4.41222 3.6973 2.46664 13.4727 0.5Z" fill="url(#paint1_linear_15654_38884)" />
    <path d="M8.55998 7.76763L10.2324 8.52709L8.55998 9.28742L7.79962 10.9598L7.04014 9.28742L5.3677 8.52709L7.04014 7.76763L7.79962 6.09524L8.55998 7.76763Z" fill="url(#paint2_linear_15654_38884)" />
    <defs>
      <linearGradient id="paint0_linear_15654_38884" x1="-2.18519" y1="9.10294" x2="17.8162" y2="9.18068" gradientUnits="userSpaceOnUse">
        <stop stopColor="#1F87DC" />
        <stop offset="0.403846" stopColor="#9154E9" />
        <stop offset="0.644231" stopColor="#9154E9" />
        <stop offset="1" stopColor="#3BB4A6" />
      </linearGradient>
      <linearGradient id="paint1_linear_15654_38884" x1="-2.18519" y1="9.10294" x2="17.8162" y2="9.18068" gradientUnits="userSpaceOnUse">
        <stop stopColor="#1F87DC" />
        <stop offset="0.403846" stopColor="#9154E9" />
        <stop offset="0.644231" stopColor="#9154E9" />
        <stop offset="1" stopColor="#3BB4A6" />
      </linearGradient>
      <linearGradient id="paint2_linear_15654_38884" x1="-2.18519" y1="9.10294" x2="17.8162" y2="9.18068" gradientUnits="userSpaceOnUse">
        <stop stopColor="#1F87DC" />
        <stop offset="0.403846" stopColor="#9154E9" />
        <stop offset="0.644231" stopColor="#9154E9" />
        <stop offset="1" stopColor="#3BB4A6" />
      </linearGradient>
    </defs>
  </svg>
);

Ai.propTypes = {
  className: string,
  notUseClass: bool,
  style: shape({}),
};

export default Ai;
